import { makeStyles } from '@fluentui/react-components';
import DataGridContent from './datagrid-content';
import AutomationRuleActivityProvider from './activity-provider';
import ActivityFilterControl from './filter';

export default function AutomationRuleActivity() {
	const classes = useStyles();
	return (
		<AutomationRuleActivityProvider>
			<ActivityFilterControl />
			<div className={classes.root}>
				<DataGridContent />
			</div>
		</AutomationRuleActivityProvider>
	);
}

export const useStyles = makeStyles({
	root: {
		height: '100%',
		width: '100%',
		position: 'relative',
	},
	content: {
    
	}
});